import React from 'react';

import ForgotPasswordForm from 'components/ForgotPasswordForm';

import * as S from 'assets/styles/authStyled';
import loginImage from 'assets/img/loginImage.webp';

const ForgotPassword = () => {
    return (
        <S.AuthContainer>
            <S.AuthImageBox>
                <S.AuthImage src={loginImage} alt="" />
            </S.AuthImageBox>
            <S.AuthForm>
                <ForgotPasswordForm />
            </S.AuthForm>
        </S.AuthContainer>
    );
};

export default ForgotPassword;
